import { useAppSelector } from '@/store/hooks'
import { helper } from '@/utils'

export default function useIsSuperAdministrator() {
  const { currentUser } = useAppSelector(s => s.users)

  return helper.isSuperAdministrator(currentUser)
}
